import React from 'react'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { font } from '@mobi/component-library/Foundations'
import type { MetaDataHighlight, SearchResultAcceptor } from '@core/Areas/Search/types'
import { ResultContentListRow } from '@core/Areas/Search/Components/Common/ResultContentListRow'
import { HighlightDisplay } from '@core/Areas/Search/Components/Common/HighlightDisplay'
import { LocationTime } from '../Common/LocationTime'
import { SearchSilkImage } from './Components/SearchSilkImage'

export const AcceptorResult: React.FC<{
  searchResult: SearchResultAcceptor
  highlights: MetaDataHighlight
}> = ({ searchResult, highlights }) => {
  const { acceptor } = searchResult

  const advertisedStartTime = acceptor.race.isStartTimeRelevant
    ? acceptor.race.advertisedStartTime
    : undefined

  const fixedPrices = acceptor.fixedOddsPrices

  return (
    <ResultContentListRow
      testId='SearchResultAcceptor'
      topContent={
        <LocationTime
          locationName={acceptor.race.fixture.name}
          raceNumber={acceptor.race.number}
          advertisedStartTime={advertisedStartTime}
          code={acceptor.race.fixture.contestType}
          status={acceptor.race.status}
          highlightKey='acceptor.race.fixture.name'
          highlights={highlights}
          scratchedStatus={acceptor.scratchedStatus}
        />
      }
      primaryText={
        <>
          {acceptor.numberOrBox}
          {' - '}
          <HighlightDisplay
            displayText={acceptor.name}
            highlightKey='acceptor.name'
            highlights={searchResult.metadata.highlights}
          />
        </>
      }
      leftContent={
        <SearchSilkImage
          meetingId={acceptor.race.fixture.id}
          meetingDate={acceptor.race.fixture.date}
          raceNo={acceptor.race.number}
          isDogsSilk={acceptor.race.fixture.contestType === 'Dogs'}
          isTrots={acceptor.race.fixture.contestType === 'Trots'}
          acceptorNumber={acceptor.numberOrBox}
        />
      }
      secondaryText={
        <>
          {acceptor.riderName && (
            <span>
              J:{' '}
              <HighlightDisplay
                displayText={acceptor.riderName}
                highlightKey='acceptor.riderName'
                highlights={searchResult.metadata.highlights}
              />
            </span>
          )}
          {acceptor.driverName && (
            <span>
              D:{' '}
              <HighlightDisplay
                displayText={acceptor.driverName}
                highlightKey='acceptor.driverName'
                highlights={searchResult.metadata.highlights}
              />
            </span>
          )}
          {acceptor.trainerName && (
            <span>
              T:{' '}
              <HighlightDisplay
                displayText={acceptor.trainerName}
                highlightKey='acceptor.trainerName'
                highlights={searchResult.metadata.highlights}
              />
            </span>
          )}
        </>
      }
      rightContent={
        fixedPrices &&
        (fixedPrices.win.isValid || fixedPrices.place.isValid) && (
          <Flex flexDirection='column' alignItems='flex-end'>
            <span style={{ fontWeight: font.weight.medium }}>
              {!fixedPrices.win.isValid ? '-' : fixedPrices.win?.dividend?.toFixed(2)}
            </span>
            <span style={{ fontWeight: font.weight.medium }}>
              {!fixedPrices.place.isValid ? '-' : fixedPrices.place?.dividend?.toFixed(2)}
            </span>
          </Flex>
        )
      }
    />
  )
}
